import api from './trackerAPI'
import { setUser } from '../user/userAction'
import { setSharesLeft } from '../share/shareAction'
import {
	findFirstStatus,
	findLastStatusKey
} from '../../../resources/constants/PaymentStatus'
import StatusGroupMap, {
	findStatusGroupNameByStatusKey
} from '../../../utils/mapping/StatusGroupMap'

/**
 * Run process that load a tracker from a token
 */
export const getTracker = (token, isDemo) => (dispatch) => {
	dispatch(getTrackerStart())
	api
		.setTracker(token, isDemo)
		.then((res) => dispatch(setTracker(res, isDemo)))
		.then(() => {
			dispatch(getTrackerSuccess())
		})
		.catch((error) => {
			dispatch(getTrackerError(error))
		})
}

export const setTracker = (res, isDemo) => (dispatch) => {
	const data = JSON.parse(JSON.stringify(res))

	if (isDemo) {
		const params = new URLSearchParams(window.location.search);

		const amount = params.get('amount');
		if (amount) {
			data.paymentInfo.amount.amount = amount;
		}

		const currency = params.get('currency');
		if (currency) {
			data.paymentInfo.amount.currency = currency;
		}

		const creditorName = params.get('creditorName');
		if (creditorName) {
			data.creditorInfo.name = creditorName;
		}

		const beneficiaryName = params.get('beneficiaryName');
		if (beneficiaryName) {
			data.beneficiaryInfo.name = beneficiaryName;
		}
		
		const now = new Date()

		const emissionDateString = params.get('emissionDate');
		if (emissionDateString) {
			const emissionDate = new Date(emissionDateString);

			if (
				now.getDate() === emissionDate.getDate() &&
				now.getMonth() === emissionDate.getMonth() &&
				now.getFullYear() === emissionDate.getFullYear()
			) {
				data.paymentStatusHistory.splice(-3)
			} else {
				now.setDate(emissionDate.getDate())
				now.setMonth(emissionDate.getMonth())
				now.setFullYear(emissionDate.getFullYear())
			}
		}
		
		data.paymentStatusHistory
			.reverse()
			.map((payment) => {
				now.setMinutes(now.getMinutes() - 72)

				payment.emissionDate = now.toISOString()
			})
			.reverse()
	}

	dispatch(setCreditor(data.creditorInfo))
	dispatch(setBeneficiary(data.beneficiaryInfo))

	const statusList = data.paymentStatusHistory;

	const orderedStatus = statusList.sort((a, b) => {
		return new Date(a.emissionDate) < new Date(b.emissionDate) ? 1 : -1
	})

	dispatch(setPayment(data, orderedStatus))
	dispatch(setBankList(orderedStatus))

	dispatch(setUser(data))
	dispatch(setSharesLeft(data.sharesLeft))
}

export const setCreditor = (payload) => ({
	type: 'SET_CREDITOR',
	payload: payload
})

export const setBeneficiary = (payload) => ({
	type: 'SET_BENEFICIARY',
	payload: payload
})

export const setPayment = (payload, orderedStatus) => {
	payload.paymentInfo.lastStatus = findLastStatusKey(orderedStatus)

	payload.paymentInfo.statusGroupName = findStatusGroupNameByStatusKey(
		payload.paymentInfo.lastStatus
	)

	payload.paymentInfo.statusGroup = StatusGroupMap[payload.paymentInfo.statusGroupName]

	payload.paymentInfo.firstStatus = findFirstStatus(orderedStatus)

	return {
		type: 'SET_PAYMENT',
		payload: payload.paymentInfo
	}
}

export const setPaymentToken = (payload) => ({
	type: 'SET_PAYMENT_TOKEN',
	payload: payload
})

/**
 * Group tracker line by bank, calculate group data and set bank history
 * @param {*} error Detail of the issue
 */
export const setBankList = (orderedStatus) => {
	const bankList = []
	orderedStatus.map((status) => {
		const bankItemKey = status.bank.bic ?? status.bank.clearingCode

		let myBank = bankList.find((bank) => {
			return bank.id === bankItemKey
		})

		if (myBank) {
			myBank.firstEmissionDate = status.emissionDate
			myBank.transactionFees = {
				amount: myBank.transactionFees.amount + status.transactionFees.amount,
				currency: myBank.transactionFees.currency
			}
			myBank.history.push({
				paymentStatus: status.paymentStatus,
				date: status.emissionDate ? status.emissionDate : status.integrationDate
			})
		} else {
			bankList.unshift({
				id: status.bank.bic ?? status.bank.clearingCode,
				bank: status.bank,
				lastStatus: status.paymentStatus,
				lastEmissionDate: status.emissionDate,
				firstEmissionDate: status.emissionDate,
				history: [],
				transactionFees: status.transactionFees
			})
		}
		return status
	})

	return {
		type: 'SET_BANK_LIST',
		payload: bankList
	}
}

/**
 * Initialize loading state
 */
export const getTrackerStart = () => ({
	type: 'GET_TRACKER_START'
})

/**
 * Run when everything is done and OK
 */
export const getTrackerSuccess = () => ({
	type: 'GET_TRACKER_SUCCESS'
})

/**
 * Run when there is an issue with the request
 * @param {*} error Detail of the issue
 */
export const getTrackerError = (error) => ({
	type: 'GET_TRACKER_ERROR',
	payload: error
})
